import { NAVIGATE } from "./types";

export default (state = {}, action) => {
    let { result, type } = action;

    switch (type) {
        case NAVIGATE:
            return {
                ...state,
                [result.view]: { ...state[result.view], selected: result.item }
            };

        default:
            return state;
    }
};
